import React from "react";
import {useDroppable} from "@dnd-kit/react";
import {useSortable} from "@dnd-kit/react/sortable";
import {FaThumbtack} from "react-icons/fa6";
import AddCardForm from "./add-card-form";
import DemandCard from "./demand-card";
import EditableTitle from "./editable-title";
import ListActionsMenu from "./list-actions-menu";
import Button from "../../../components/button";

const BoardList = ({list, listIndex, lists, cards, users, onAddCard, onRequestAddCard, onUpdateListTitle, onToggleCard, onOpenCard, onCopyList, onMoveList, onMoveAllCards, onTogglePin, onDeleteList, onDiscardList, addCardRequest, isDragDisabled, readOnly}) => {
    const hasTitle = Boolean(String(list.title ?? "").trim());
    const {ref: dropRef, isDropTarget} = useDroppable({
        id: `demand-list-dropzone:${list.id}`,
        accept: "demand-card",
        data: {listId: list.id, isListDropzone: true},
        collisionPriority: -1,
        disabled: isDragDisabled || !hasTitle,
    });
    const {ref: listRef, isDragging: isListDragging} = useSortable({
        id: `demand-list:${list.id}`,
        index: listIndex,
        group: "board-lists",
        type: "demand-list",
        accept: "demand-list",
        data: {listId: list.id},
        disabled: {draggable: isDragDisabled || list.pinned || !hasTitle, droppable: isDragDisabled || !hasTitle},
    });

    return (
        <section ref={listRef} className={`flex max-h-full w-[300px] min-w-[300px] flex-col rounded-xl border shadow-sm transition-colors ${list.pinned || isDragDisabled || !hasTitle ? "" : "cursor-grab active:cursor-grabbing"} ${isListDragging ? "opacity-45" : ""} ${isDropTarget ? "border-blue-300 bg-blue-50" : "border-slate-200 bg-slate-100"}`}>
            <header className="flex items-center justify-between px-2 pb-2 pt-3">
                <div className="flex min-w-0 items-center gap-1.5">
                    <EditableTitle value={list.title} onSave={title => onUpdateListTitle(list.id, title)} onEmptyBlur={() => onDiscardList(list.id)} label={`Título da lista ${list.title}`} className="min-w-0 text-sm font-bold text-slate-700" inputClassName="w-full text-sm font-bold text-slate-700" initiallyEditing={list.isNew} requireValue={list.isNew} readOnly={readOnly} />
                    <span className="rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-bold text-slate-500">{cards.length}</span>
                </div>
                {hasTitle && !readOnly && <div className="flex items-center">
                    <Button type="button" onClick={() => onTogglePin(list.id)} title={list.pinned ? "Desafixar lista" : "Fixar lista"} col={`!h-7 !w-7 !border-0 !bg-transparent !p-0 !shadow-none hover:!bg-slate-200 ${list.pinned ? "!text-blue-600" : "!text-slate-300 hover:!text-slate-600"}`}><FaThumbtack /></Button>
                    <ListActionsMenu list={list} lists={lists} onAddCard={() => onRequestAddCard(list.id)} onCopy={() => onCopyList(list.id)} onMove={position => onMoveList(list.id, position)} onMoveCards={targetId => onMoveAllCards(list.id, targetId)} onTogglePin={() => onTogglePin(list.id)} onDelete={() => onDeleteList(list.id)} />
                </div>}
            </header>

            <div ref={dropRef} className="flex flex-1 flex-col gap-2 overflow-y-auto px-2 pb-2">
                {cards.map((card, index) => <DemandCard key={card.id} card={card} index={index} listId={list.id} users={users} onToggleCompleted={() => onToggleCard(card.id)} onOpen={() => onOpenCard(card.id)} isDragDisabled={isDragDisabled} />)}
            </div>

            {hasTitle && !readOnly && <div className="px-2 pb-2"><AddCardForm id={`quick-card-title-${list.id}`} openRequest={addCardRequest} onAdd={title => onAddCard(list.id, title)} /></div>}
        </section>
    );
};

export default BoardList;
